import React from 'react';

import { Spin, Layout } from 'antd';
import { useSystemConfig, usePageLoading, useRouterStatus } from '#/store';
import { getLayoutMode } from '#/util/router';
import { onlyShowContentMode } from '@src/layout/common/constant';

import './index.scss';

export const PageLoading = () => {
  const [{ tip }] = usePageLoading();
  return (
    <Spin wrapperClassName="ads-page-loading" spinning tip={tip}>
      <div style={{ width: '100wh', height: 'calc(100vh - 54px - 38px - 54px - 60px)' }} />
    </Spin>
  );
};

const { Content } = Layout;

const MainContent = () => {
  const [{ loading }] = usePageLoading();
  const [{ curPageConfig }] = useSystemConfig();
  const [{ ContentNodeList, ActiveConfig }] = useRouterStatus();
  const mode = getLayoutMode(curPageConfig);
  const getStyles = () => {
    const style = {};
    if (mode === onlyShowContentMode) {
      style.height = '100%';
      style.marginTop = 'unset';
    }
    return style;
  };

  return (
    <>
      <Content
        className="wkd-layout-main-content wkd-layout-main-content-ads"
        id="wkd-layout-main-content"
        style={{
          ...getStyles(),
          ...(curPageConfig?.layout?.style || {}),
        }}
      >
        <>
          {ContentNodeList.map((content) => {
            const { ContentNode, fullPath = '', routerQuery } = content || {};
            return (
              <div
                className="wkd-layout-tab-content"
                key={fullPath}
                data-active={ActiveConfig.fullPath === fullPath}
                style={{
                  display: ActiveConfig.fullPath === fullPath ? 'block' : 'none',
                }}
              >
                <div className="tab-content-node-box">
                  <div className="content-node">
                    {ContentNode ? (
                      <div style={{ display: loading ? 'none' : 'block' }}>
                        <ContentNode routerParam={routerQuery} />
                      </div>
                    ) : null}
                    {!ContentNode || loading ? <PageLoading /> : null}
                  </div>
                </div>
              </div>
            );
          })}
        </>
      </Content>
    </>
  );
};

export default MainContent;
